import { z } from 'zod';

const mtrTemplateSpecRuleSchema = z.object({
  id: z.string().optional(),
  mtrSpecId: z.string().min(1, '請選擇規格'),
  required: z.boolean(),
  displayOrder: z.coerce.number().int().min(0, '排序不可小於 0'),
});

export const mtrTemplateFormSchema = z.object({
  mtrStructMainId: z.string().min(1, '請選擇主分類'),
  mtrStructSubId: z.string().min(1, '請選擇次分類'),
  code: z.string().trim().min(1, '代號不能為空').max(50, '代號最多 50 字'),
  name: z.string().trim().min(1, '名稱不能為空').max(100, '名稱最多 100 字'),
  remark: z.string().max(500, '備註最多 500 字').optional().or(z.literal('')),
  serialFormatter: z.string().trim().min(1, '序號格式不能為空').max(4000, '序號格式過長'),
  specs: z.array(mtrTemplateSpecRuleSchema).min(1, '至少需要一筆規格規則'),
});

export const MTR_TEMPLATE_DEFAULT_VALUES = {
  mtrStructMainId: '',
  mtrStructSubId: '',
  code: '',
  name: '',
  remark: '',
  serialFormatter: '',
  specs: [],
};
